import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastProvider } from './components/index.js';
import { AuthProvider } from './lib/auth-context.js';
import { Analytics } from './lib/analytics/Analytics.js';
import { RequireAuth } from './components/RequireAuth.js';
import { Home } from './routes/home.js';
import { InternalDesign } from './routes/internal/design.js';
import { Corrections } from './routes/internal/corrections.js';
import { Login } from './routes/auth/login.js';
import { Signup } from './routes/auth/signup.js';
import { AccessDenied } from './routes/access-denied.js';
import { Dashboard } from './routes/dashboard.js';
import { Profile } from './routes/settings/profile.js';
import { Users } from './routes/settings/users.js';
import { STTTool, JobsTool, JobDetail } from './routes/tools/index.js';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Analytics />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/internal/design" element={<InternalDesign />} />
            <Route
              path="/internal/corrections"
              element={
                <RequireAuth>
                  <Corrections />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/settings/profile"
              element={
                <RequireAuth>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route
              path="/settings/users"
              element={
                <RequireAuth>
                  <Users />
                </RequireAuth>
              }
            />
            <Route
              path="/tools/jobs"
              element={
                <RequireAuth>
                  <JobsTool />
                </RequireAuth>
              }
            />
            <Route
              path="/tools/jobs/:id"
              element={
                <RequireAuth>
                  <JobDetail />
                </RequireAuth>
              }
            />
            <Route
              path="/tools/stt"
              element={
                <RequireAuth>
                  <STTTool />
                </RequireAuth>
              }
            />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
